// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__ByKQU","inner":"style_inner__rdOAG","itemList":"style_itemList__n0YoV","social-container":"style_social-container__RY-CU"};